import type { ReactNode } from 'react';

export const symbol_signal_cellular_connected_no_internet_4_bar: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m131-131 697-697q14-14 33-6.34 19 7.65 19 27.34v152h-30q-45.83 0-77.92 32.08Q740-590.83 740-545v465H152q-20 0-27.5-18.5T131-131Zm697.5 42.32q-8.5-8.67-8.5-21.5 0-12.82 8.68-21.32 8.67-8.5 21.5-8.5 12.82 0 21.32 8.68 8.5 8.67 8.5 21.5 0 12.82-8.68 21.32-8.67 8.5-21.5 8.5-12.82 0-21.32-8.68ZM820-230v-315q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v316q0 12-9 20.5t-21.5 8.5q-12.5 0-21-8.63-8.5-8.62-8.5-21.37Z"
		/>
	</svg>
);
